module.exports = __webpack_public_path__ + "static/danwei-edfd1afdd45eef89d80f04b9776a69aa.png";